import React from 'react';
import { useRouter } from 'next/router';
import { Col, Grid, Row } from 'antd';

import ImageC from 'src/components/Image';
import g from 'src/constants/global';

const terapyType = [
	{
		title: 'Terapi Stem Cell di Indonesia',
		description:
			// eslint-disable-next-line max-len
			'Pengobatan menggunakan stem cell menjadi suatu terobosan yang berpotensi menyembuhkan berbagai penyakit berat, kronis, degeneratif, dan autoimun.',
		image: '/images/stem-cell/cell-dna.png',
		url: g.STEM_CELL.URLS.REGISTER,
		external_link: true,
	},
	{
		title: 'Terapi Secretome di Indonesia',
		description:
			// eslint-disable-next-line max-len
			'Terapi kesehatan secretome kini menjadi populer karena dianggap mampu meringankan berbagai kondisi klinis seperti peradangan, peremajaan kulit hingga masalah kebotakan.',
		image: '/images/stem-cell/cell-embrio.png',
		url: '/info-stem-cell/secretome',
		external_link: false,
	},
];

const TerapiType = () => {
	const r = useRouter();
	const { xs, xl } = Grid.useBreakpoint();

	return (
		<div className="bg-white">
			<div className="container py-3">
				<div className="py-3 text-center">
					<h2 className="mb-2 text-5xl font-bold max-xl:text-2xl max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
						Jenis Terapi
					</h2>
				</div>
				<Row gutter={{ md: 60, xs: 0 }}>
					{terapyType.map((item, idx) => (
						<Col
							key={idx}
							md={12}
							xs={24}
							style={{ borderRadius: '17px', marginTop: idx === 1 && xs ? '20px' : 0 }}
						>
							<div className="relative z-10 text-center flex items-center justify-center">
								<ImageC
									width={xl ? 160 : 95}
									height={xl ? 160 : 95}
									src={item.image}
									srcSet=""
									alt=""
									style={{ borderRadius: '17px', position: 'relative', zIndex: 10 }}
								/>
							</div>
							<div className="-mt-12.5 relative rounded-[17px] shadow-[0px_8px_24px_0px_rgba(24,27,30,0.08)]">
								<div className="pt-18 pl-0.75 pr-0.5">
									<div className="min-h-[300px] max-xl:min-h-[150px] px-5">
										<h3 className="mb-6 text-3xl font-bold max-xl:text-base">
											{item.title}
										</h3>
										<p className="mt-4 text-2xl max-xl:text-sm max-xs:text-neutral-5">
											{item.description}
										</p>
									</div>
									<div className="py-4 text-center">
										<a href={item.url} rel="noopener noreferrer">
											<span
												className="inline-block rounded-[30px] border border-black cursor-pointer px-[55px] py-[9px] bg-white text-[22px] font-bold max-xl:text-xs max-xl:px-[30px] max-xs:px-[65px] max-xs:py-[15px] hover:text-primary"
												onClick={() => r.push(item.url!)}
											>
												Pelajari di Sini!
											</span>
										</a>
									</div>
								</div>
							</div>
						</Col>
					))}
				</Row>
			</div>
		</div>
	);
};

export default TerapiType;
